import {
  fetchGlassBeads,
  fetchInventory,
  fetchManufacturers,
  fetchMaterials,
} from 'store/supplies/suppliesOperations';

const LABELS = {
  materials: 'formula',
  manufacturers: 'manufacturer',
  inventory: 'material',
  glassBeads: 'Reflective Media',
};

// ArchiveImpactDto key -> the list that goes stale once the key comes back filled
const IMPACT_ENTITIES = {
  material: 'materials',
  formulas: 'materials',
  manufacturer: 'manufacturers',
  bead: 'glassBeads',
  inventory: 'inventory',
};

const REGISTER_FETCH = {
  materials: () => fetchMaterials(null, false, false),
  manufacturers: () => fetchManufacturers(),
  inventory: () => fetchInventory(),
  glassBeads: () => fetchGlassBeads(),
};

const isFilled = (value) => (Array.isArray(value) ? value.length > 0 : Boolean(value));

export const impactedEntities = (impact) =>
  Array.from(
    new Set(
      Object.entries(impact || {})
        .filter(([key, value]) => IMPACT_ENTITIES[key] && isFilled(value))
        .map(([key]) => IMPACT_ENTITIES[key])
    )
  );

export const refetchSupplies = (dispatch, entities) =>
  entities.forEach((entity) => dispatch(REGISTER_FETCH[entity]()));

const plural = (noun, count) => (count > 1 ? `${noun}s` : noun);

const section = (title, records) => ({ title, items: records });

const archiveSections = (entity, { material, manufacturer, bead, inventory, formulas }) =>
  [
    material && section('The following formula will be archived as well:', [material]),
    manufacturer && section('The following manufacturer will be archived as well:', [manufacturer]),
    bead && section('The following Reflective Media will be archived as well:', [bead]),
    isFilled(inventory) &&
      section(`The following ${plural('material', inventory.length)} will be archived as well:`, inventory),
    isFilled(formulas) &&
      section(
        `${entity === 'glassBeads' ? 'This' : 'The'} Reflective Media will be removed from the following ${plural('formula', formulas.length)}:`,
        formulas
      ),
  ].filter(Boolean);

// the impact lands after the dialog is already open, so the copy has to read as empty until then
export const archiveCopy = (entity, action, impact) => {
  const { inventory } = impact || {};

  return action === 'purge'
    ? {
        text: `Are you sure you want to permanently delete this ${LABELS[entity]}?`,
        sections: isFilled(inventory)
          ? [section(`The following archived ${plural('material', inventory.length)} will be deleted as well:`, inventory)]
          : [],
      }
    : {
        text: `Are you sure you want to archive this ${LABELS[entity]}?`,
        sections: archiveSections(entity, impact || {}),
      };
};
